var _rect, _rect2, _mask, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 23,
    height: 28,
    rx: 1,
    fill: "current",
    stroke: "#121212",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1_1750",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14C15 12.8954 15.8954 12 17 12H38C39.1046 12 40 12.8954 40 14V40C40 41.1046 39.1046 42 38 42H17C15.8954 42 15 41.1046 15 40V14Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 11.7909 14.7909 10 17 10H36C38.2091 10 40 11.7909 40 14C40 14 39.1046 14 38 14H17H13ZM40 42H15H40ZM17 42C14.7909 42 13 40.2091 13 38V14C13 11.7909 14.7909 10 17 10V14V40C17 41.1046 17 42 17 42ZM40 12V42V12Z",
    fill: "#121212",
    mask: "url(#path-3-inside-1_1_1750)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareCopy);
export default __webpack_public_path__ + "static/media/shareCopy.a5a31083dfb0e297f7ab06c5b07d0916.svg";
export { ForwardRef as ReactComponent };